import React from 'react';

const Divider = ({id}) => <div className="drawer pt-3" id={id}></div>
export default Divider;